<template>
  <div :class="[{'required': selfInputs.required, 'editable': !selfInputs.readOnly, 'pure-mode' : selfInputs.lightMode, checked : isChecked, unchecked : !isChecked}]">
    <label class="label">{{ selfInputs.label }}</label>
    <div class="toggle-container">
      <label id="left">{{ selfInputs.left.label }}</label><!-- valeur uncheck -->
      <div class="switch-container">
        <label class="switch" >
          <input id="checkbox" type="checkbox" @click.prevent="toggle" v-model=isChecked :readonly="selfInputs.readOnly">
          <span class="slider round"></span>
        </label>
      </div>
      <label id="right" >{{ selfInputs.right.label }}</label><!-- valeur check -->
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLock } from "@fortawesome/free-solid-svg-icons";

library.add(faLock);

export default {
  name: 'CustomSwitchField',
  props: ['content', 'toggleConditions'],
  data: function () {
    return {
      selfInputs: this.content,
      isChecked: false
    };
  },
  watch: {
    "selfInputs.value"(e) {
      this.isChecked = e === this.selfInputs.right.value;
    },
  },
  mounted(){
    this.isChecked = this.selfInputs.value === this.selfInputs.right.value;
  },
  methods: {
    async toggle(item) {
      // toggleConditions is used for confirmation modal
      if(this.toggleConditions){
        const res = await this.toggleConditions();
        if(!(res)){
          return
        }
      }
      if(this.selfInputs.readOnly){ return }
      this.selfInputs.value = this.selfInputs.value === this.selfInputs.right.value ? this.selfInputs.left.value : this.selfInputs.right.value;
      item.active = !item.active;
    }
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
.label
  display block
  margin 8px 0 4px 2px
  color CTRL_TEXT_MUTED
  font-size 0.82em
  font-weight 600

.toggle-container
  box-sizing border-box
  height CTRL_HEIGHT
  padding-left CTRL_PADDING_X
  padding-right CTRL_PADDING_X
  gap 1rem
  background-color transparent
  border-radius CTRL_RADIUS
  border 1px solid transparent
  transition background-color CTRL_EASE, border-color CTRL_EASE

  display grid
  grid-template-columns repeat(5, 1fr)
  grid-template-rows 1fr
  grid-column-gap 0
  grid-row-gap 0

  #left, .switch-container, #right
    display flex
    align-items center
    justify-content center
    color CTRL_TEXT_MUTED

  #left
    grid-area 1 / 1 / 2 / 3

  .switch-container
    grid-area 1 / 3 / 2 / 4
    width 55px

  #right
    grid-area 1 / 4 / 2 / 6

  #left, #right, .switch
    background-color rgba(255, 255, 255, 0)

/* TOGGLE SWITCH STYLES */
.switch
  position relative
  display inline-block
  width 48px
  height 28px

.switch input
  opacity 0
  width 0
  height 0

.slider
  position absolute
  cursor default
  top 0
  left 0
  right 0
  bottom 0
  background-color #d3d8e4
  -webkit-transition .25s
  transition .25s

.slider:before
  position absolute
  content ""
  height 22px
  width 22px
  left 3px
  bottom 3px
  background-color white
  box-shadow 0 1px 3px rgba(23, 35, 63, 0.3)
  -webkit-transition .25s
  transition .25s

.checked
  .switch
    input + .slider:before
      -webkit-transform translateX(20px)
      -ms-transform translateX(20px)
      transform translateX(20px)

.slider.round
  border-radius 34px

.slider.round:before
  border-radius 50%

/* CIRCLE STYLES AND ANIMATION */

.darkCircle.grow
  animation-name circle-grow
  animation-duration 0.7s
  animation-timing-function ease-in-out

.lightCircle.grow
  animation-name circle-grow
  animation-duration 0.7s
  animation-timing-function ease-in-out


@keyframes circle-grow
  0%
    clip-path circle(0% at 50% 0%)

  100%
    clip-path circle(150% at 50% 0%)

.toggle-container
  label
    font-weight 100

.checked
  #right
    font-weight bold

.unchecked
  #left
    font-weight bold

// Lecture seule : piste "on" estompée
.checked .slider
  background-color #8f9bb8

.editable
  label
    color CTRL_LABEL

  .toggle-container
    background-color CTRL_BG
    border-color CTRL_BORDER

    &:hover
      background-color CTRL_BG_HOVER
      border-color CTRL_BORDER_HOVER

    label
      color CTRL_TEXT_MUTED
      // Libellés gauche/droite : jamais de fond propre, ils reprennent celui du champ
      background-color transparent !important

    .slider
      cursor pointer
      background-color #8f9bb5

  &.checked .slider
    background-color THEME_COLOR_PRIMARY

// Côté actif en texte plein, côté inactif estompé
.editable.checked #right, .editable.unchecked #left
  color CTRL_TEXT

.pure-mode
  .toggle-container
    display flex
    padding 0
    border none
    background-color transparent

    &:hover
      background-color transparent

  #left, #right, .label
    display none

.required label::after
  content " *"
  color CTRL_ERROR
</style>